import React from "react";
import direction from "../../../service/direction.json";
const InternetPhoneCosts = () => {
  return (
    <div className="form-group row col-md-12 text-justify">
      <div className="col-md-8">
        <div style={{ width: "18rem;", fontSize: "20px" }}>
          <div className="card-body">
            <h5 className="card-title text-bold" style={{ fontSize: "30px" }}>
              هزینه های تلفن اینترنتی
            </h5>
            <p className="card-text">
              <span className="text-bold">
                هزینه های این سرویس در 3 طبقه یا مرحله میباشد.
              </span>
              <ol type="1">
                <li>
                  <span className="text-bold">هزینه خرید و فعالسازی خط: </span>
                  هزینه خط 100هزارتومان و فعالسازی 50هزارتومان یعنی جمعا
                  150هزارتومان میباشد که در جشنواره فعلی آسیاتک برای شما
                  100هزارتومان شارژ هدیه سه ماهه روی خط ثبت نامی تعلق میگیرد با
                  این تعاریف در واقع هزینه خط رایگان محاسبه میشود! در ضمن مالکیت
                  دائمی خطوط خریداری شده با خود کاربر میباشد و نیازی به تمدید
                  های ماهانه و سالانه نیست.
                </li>
                <br />
                <li>
                  <span className="text-bold">هزینه های دایورت: </span>
                  همانطور که در توضیحات قبلی هم اشاره شد این سرویس (تلفن مجازی
                  اینترنتی) بصورت دایورت روی تلفن های واقعی کار میکند و شما در
                  حالتها و داخلی های مختلف تماسهای دریافتی تلفن ابری را روی تلفن
                  ثابت واقعی و یا شماره موبایل خود دایورت میکنید که هزینه های
                  دایورت به این شرح است:
                  <ol type="1">
                    <li>دایورت داخل استانی هر دقیقه 4 و نیم تومان</li>
                    <li>دایورت بین استانی هر دقیقه 33 تومان</li>
                    <li>دایورت به موبایل هر دقیقه 62 تومان</li>
                    <li>دایورت به تلفن ابری دیگر آسیاتک ، رایگان</li>
                  </ol>
                </li>
                <br />
                <li>
                  <span className="text-bold"> هزینه ماهانه سرویس هاستد: </span>
                  شما با خرید یکباره یک خط تلفن ابری بدون هزینه های ماهانه
                  میتوانید یک دایورت ساده روی یک خط تلفن واقعی خود (ثابت یا
                  موبایل) داشته باشید و همینطور میتوانید تحت اینترنت آسیاتک و با
                  استفاده از نرم افزارهای مدیریت تلفن ابری مانند اپ زوپیر و
                  آسیاتل و … تماس های ابری خود را انجام دهید.
                  <br />
                  ولی ما سرویسی با عنوان “سرویس هاستد” برای شما فراهم کرده ایم
                  که بدون هیچ اینترنت و سخت افزار و نرم افزار خاصی میتوانید از
                  امکانات اضافی منحصر به فرد ivr ، تعریف داخلی ها، تعریف صف
                  تماس، ارسال فکس و تماس خروجی استفاده کنید. تمام این امکانات
                  بصورت تنظیمات منویی در داخل پنل سامانه سایه بان انجام میشود.
                  هزینه ماهانه سرویس هاستد 80 هزارتومان میباشد.
                </li>
              </ol>
            </p>
          </div>
        </div>
      </div>
      <div className="row col-md-4 text-center">
        <img
          src={`${direction.ImgDesign}phone_web_SIP_Trunk.png`}
          alt="سایه بان"
        />
        <img
          src={`${direction.ImgDesign}cloud-fon-priceing.png`}
          alt="سایه بان"
        />
      </div>
    </div>
  );
};

export default InternetPhoneCosts;
